import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import useMarkets from 'hooks/useMarkets'
import { detectMarket } from 'shared/functions/detectMarket'
import { SET_LOCALE } from 'store/actions'

import { getStoredLanguage, normalizeLanguage } from './language'

// Applies the market's language until the user makes an explicit choice, then mirrors
// the active language into redux so the MUI theme can switch its locale bundles.
const LanguageSync = () => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const { currentUser } = useSelector((state) => state.customization)
  const { defaultMarket, markets } = useMarkets()

  const office = currentUser?.office

  const marketLanguage = useMemo(() => {
    const userMarket = office ? markets.find((item) => item.OfficeId === office) : null
    const detectedMarket = markets.find((market) => market.Code === detectMarket(markets, defaultMarket))
    return normalizeLanguage((userMarket || detectedMarket)?.Language)
  }, [defaultMarket, markets, office])

  useEffect(() => {
    if (getStoredLanguage()) return
    if (!marketLanguage) return

    const current = normalizeLanguage(i18n.resolvedLanguage)
    if (current !== marketLanguage) i18n.changeLanguage(marketLanguage)
  }, [i18n, marketLanguage])

  useEffect(() => {
    dispatch({ type: SET_LOCALE, locale: normalizeLanguage(i18n.resolvedLanguage) || 'en' })
  }, [dispatch, i18n.resolvedLanguage])

  return null
}

export default LanguageSync
